import { ColumnFilters } from "./use-column-issues";

// Centralised TanStack Query keys for board reads. One place to define the hierarchy so the
// invalidation bridge (see use-board-invalidation) can target exactly the slice an event
// touched. All keys are prefixed with "board" so the whole feature can be invalidated at once.
//
// TanStack hashes keys structurally (object property order doesn't matter), so passing the
// ColumnFilters object directly is safe and gives each filter combination its own cache entry.
export const boardKeys = {
  all: ["board"] as const,
  // Scoped by the active project: the board is scoped server-side by currentProjectId, so config
  // (the scope → projects/boards map) MUST be cached per scope. A scope-blind key let the designer
  // overlay reuse another project's board list, whose ids then 404 as "Board '…' not found".
  config: (scope: string): readonly ["board", "config", string] => ["board", "config", scope],
  column: (
    boardId: string,
    columnId: string,
    filters: ColumnFilters
  ): readonly ["board", string, "column", string, ColumnFilters] => ["board", boardId, "column", columnId, filters],
  detail: (issueId: string): readonly ["board", "issue", string, "detail"] => ["board", "issue", issueId, "detail"],
  byKey: (key: string): readonly ["board", "issue", "byKey", string] => ["board", "issue", "byKey", key],
  reports: (boardId: string): readonly ["board", string, "reports"] => ["board", boardId, "reports"],
  burndown: (sprintId: string): readonly ["board", "sprint", string, "burndown"] => [
    "board",
    "sprint",
    sprintId,
    "burndown"
  ],
  roadmap: (boardId: string): readonly ["board", string, "roadmap"] => ["board", boardId, "roadmap"],
  archived: (boardId: string): readonly ["board", string, "archived"] => ["board", boardId, "archived"],
  versionProgress: (projectKey: string): readonly ["board", "project", string, "version-progress"] => [
    "board",
    "project",
    projectKey,
    "version-progress"
  ]
} as const;
